var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.69 9.99996L18.2083 8.39996C18.5958 7.20246 18.0566 5.89996 16.9358 5.32746L15.4383 4.56246L14.6733 3.06496C14.1008 1.94413 12.7983 1.40413 11.6008 1.79246L9.99996 2.30996L8.39996 1.79163C7.20246 1.40413 5.89996 1.9433 5.32746 3.06413L4.56163 4.56163L3.06413 5.32746C1.9433 5.89996 1.40413 7.20246 1.79163 8.39996L2.30996 9.99996L1.79163 11.6C1.40413 12.7975 1.9433 14.1 3.06413 14.6725L4.56163 15.4375L5.32663 16.935C5.89913 18.0558 7.20163 18.5958 8.39913 18.2075L9.99996 17.69L11.6 18.2083C12.7975 18.5958 14.1 18.0566 14.6725 16.9358L15.4375 15.4383L16.935 14.6733C18.0558 14.1008 18.5958 12.7983 18.2075 11.6008L17.69 9.99996ZM9.16663 13.6783L6.07746 10.5891L7.2558 9.4108L9.16663 11.3216L13.5775 6.9108L14.7558 8.08913L9.16663 13.6783Z",
    fill: "#10B2FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.90d893e2.svg";
export { ForwardRef as ReactComponent };